import { useLazyQuery } from '@apollo/client';

import SubEvent, { SubEventFilterInput } from '../../models/SubEvent';
import { GET_SUBEVENTS_GLOBAL } from './query';

interface QueryData {
  subEvents: SubEvent[];
}

interface QueryVars {
  where: Pick<SubEventFilterInput, 'masterEventId'>;
}

/**
 * Fetch sub events of the specified master events
 */
function useFetchSubEventsGlobal() {
  const [execute, { loading, error, data, refetch, called }] = useLazyQuery<QueryData, QueryVars>(
    GET_SUBEVENTS_GLOBAL,
    {
      notifyOnNetworkStatusChange: true,
    },
  );

  const fetchSubEvents = async (masterEventIds: string[]) => {
    const variables: QueryVars = {
      where: {
        masterEventId: { _in: masterEventIds },
      },
    };

    const response = called
      ? await refetch(variables)
      : await execute({
          variables,
        });

    return response.data?.subEvents || [];
  };

  return {
    fetchSubEvents,
    loading,
    error,
    subEvents: data?.subEvents || undefined,
  };
}

export default useFetchSubEventsGlobal;
